export const SITE_INFO = {
  orgName: "NUARI",
  pageTitle: "NU-SK-DB",
  copyright: "NUARI",
  logo: {
    link: "http://nuari.org",
    // line1: "The Murder Matrix",
    line2: "A Norwich University website",
  }
};
